import React, { useCallback, useContext, useMemo, useState } from 'react';
import EDDialog from '../../../../../../../BaseComponents/Dialog/EDDialog';
import { BokforderTemplateView } from '../BokforderTemplate/BokforderTemplate';
import {
  getBokforderCopyIDFromSearchParams,
  getBokforderTypeFromSearchParams,
  translateBokforderTypeToOmforingsType,
} from '../../Utils/BokforderUtils';
import BokforderContext from '../BokforderContext/BokforderContext';
import { IDialogFooterActionButton } from '../../../../../../../BaseComponents/Dialog/DialogFooter/EDDialogFooter';
import { BusinessDataFormContext } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { BokforderSettingsQuery_db_EKBokforingsmall_All } from '../../Queries/BokforderSettingsQuery/_QueryTypes/BokforderSettingsQuery';
import KonteringContext from '../../../../../_Common/Components/KonteringManager/KonteringContext';
import EDAvenyProgress from '../../../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import { useIsBreakpointOrLarger } from '../../../../../../../Components/BreakpointContext/BreakpointContextUtils';
import BokforderVerificationWizard from './Components/BokforderVerificationWizard/BokforderVerificationWizard';
import { BokforderVerificationQuery_node_TEDEKBokfver } from './Queries/_QueryTypes/BokforderVerificationQuery';
import { FormUpdateAssociatonType } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import {
  copyRows,
  getCreateDialogFooterActionLabel,
  getOmbokningstypFormUpdateValue,
  getTitlePrefix,
  IVerRow,
  makeBfoRowsFromVerRows,
  getFormUpdateWithKundInformation,
  YesOrNoEnum,
} from './Utils/BokforderCreateDialogUtils';
import {
  BokforderQuery,
  BokforderQueryVariables,
  BokforderQuery_node_TEDEKBokforder,
} from '../../Queries/_QueryTypes/BokforderQuery';
import query from '../../Queries/BokforderQuery.gql';
import queryUtanordning from '../../Queries/UtanordningQuery.gql';
import { handleGQLError } from '../../../../../../../Utils/Error';
import { NEWLY_ADDED_ID_PREFIX_FOR_UPDATE } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Const/BusinessDataFormConst';
import { useQuery } from '@apollo/client';
import { BfoRowsForTemplateType } from '../BokforderContext/BokforderContextManager';
import { getYear } from '../../../../../../../Utils/dateUtils';
import { KodplanContext } from '../../../../../../../Components/KodplanManager/Context/KodplanContext';
import { isVisibleByKontodelDate } from '../../../../../_Common/Components/KonteringManager/validateKonteringForAttestUtils';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import EDBox from '../../../../../../../BaseComponents/EDBox/EDBox';
import {
  TEDEKBokforderRadPERIODISERADEnum,
  TEDEKBokforderTYPEnum,
  TEDEKBokforderVariantEnum,
  TEDEKBokfverVERKAT_KODEnum,
  TEDOPOrgPersLokTypEnum,
} from '../../../../../../../globalQueryTypes';
import { findFormatter } from '../../../../../../../Utils/Formatters/FindFormatter';
import { IVerRowWithPeriod } from './Components/BokforderVerificationWizardStep2/BokforderVerificationWizardStep2';
import { useLocation } from 'react-router';
import {
  UtanordningQuery,
  UtanordningQueryVariables,
  UtanordningQuery_node_TEDEKBokforder,
} from '../../Queries/_QueryTypes/UtanordningQuery';
import { BokforderWrapperContext } from '../../../../Rutiner/Bokforder/Contexts/BokforderWrapperContext';
import { CreateDialogOpenEnum } from '../../../../Rutiner/Bokforder/Components/BokforderProviderWrapper';
import { ActiveDatabaseContext } from '../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import UtanordningTillgodoDialog from './Components/UtanordningTillgodoDialog/UtanordningTillgodoDialog';

export interface ISelectedVerRow {
  id: string;
  verkatKod: string;
  harAndringsVerifikation: boolean;
}

export interface ISelectedKundRow {
  KUNDNR_KONTONR: string;
  Namn: string;
  Tillgodohavande: number;
  id: string;
  _Associations: {
    OrgPers: {
      _typ: TEDOPOrgPersLokTypEnum;
    };
    KundKategori: {
      id: string;
    };
  };
}

interface IProps {
  bokfgruppId?: string;
}

const currFormatter = findFormatter('TEDFormatCurr');

const BokforderCreateDialog: React.FC<IProps> = props => {
  const isMediumOrLarger = useIsBreakpointOrLarger('md');
  const bokforderContext = useContext(BokforderContext);

  const {
    bokforderDate: bokforderContextBokforderDate,
    bokforderVariant: bokforderContextBokforderVariant,
    getKonteringsmall: bokforderContextGetKonteringsmall,
    makeNewRow: bokforderContextMakeNewRow,
    onTemplateChange: bokforderContextOnTemplateChange,
    setNewRowIndex: bokforderContextSetNewRowIndex,
    setAreYouSureModalCallback: bokforderContextSetAreYouSureModalCallback,
    setAreYouSureModalOpen: bokforderContextSetAreYouSureModalOpen,
    setBokforderVariant: bokforderContextSetBokforderVariant,
    setTillgohavandeKundTyp: bokforderContextSetTillgohavandeKundTyp,
  } = bokforderContext;

  const bokforderWrapperContext = useContext(BokforderWrapperContext);
  const bokforderWrapperContextSetCreateOptionDialogOpen =
    bokforderWrapperContext.setCreateOptionDialogOpen;

  const formContext = useContext(BusinessDataFormContext);
  const formContextDispatch = formContext?.formStateDispatch;
  const formContextUpdate = formContext?.update;
  const konteringContext = useContext(KonteringContext);
  const getKontodelByKontodel =
    konteringContext.konteringUtils.getKontodelByKontodel;
  const kodplanContext = useContext(KodplanContext);
  const { userID, activeDatabase } = useContext(ActiveDatabaseContext);

  const location = useLocation();

  const [choosenTemplate, setChoosenTemplate] =
    useState<BokforderSettingsQuery_db_EKBokforingsmall_All | null>(null);

  const [step, setStep] = useState<number>(1);
  const [selectedVerRow, setSelectedVerRow] = useState<ISelectedVerRow>();
  const [chosenRows, setChosenRows] = useState<IVerRow[]>([]);
  const [valdTillgodoKund, setValdTillgodoKund] =
    useState<ISelectedKundRow | null>(null);
  const [periodChosenRows, setPeriodChosenRows] = useState<IVerRowWithPeriod[]>(
    []
  );
  const [verification, setVerification] =
    useState<BokforderVerificationQuery_node_TEDEKBokfver | null>(null);
  const [warningDialogOpen, setWarningDialogOpen] = useState<boolean>(false);
  const [includeRowText, setIncludeRowText] = useState<boolean>(true);

  const copyID = getBokforderCopyIDFromSearchParams(location.search) ?? '';

  const isOriginal = copyID === '' || copyID == undefined;

  const type = getBokforderTypeFromSearchParams(location.search) ?? '';

  const bfoQuerySkip =
    isOriginal ||
    (type !== '' && type !== TEDEKBokforderTYPEnum.BOKFORINGSORDER);

  const utanordningQuerySkip =
    isOriginal || (type !== '' && type !== TEDEKBokforderTYPEnum.UTANORDNING);

  const { loading: copyBfoLoading } = useQuery<
    BokforderQuery,
    BokforderQueryVariables
  >(query, {
    variables: {
      id: copyID,
    },
    onError: handleGQLError,
    onCompleted: data => {
      const nodeData = data.node as BokforderQuery_node_TEDEKBokforder;

      const rows = nodeData?._Associations?.Rader;
      let newValues: FormUpdateAssociatonType[][] = [];
      const rowsForTemplate: BfoRowsForTemplateType[] = [];

      if (
        nodeData.Variant === TEDEKBokforderVariantEnum.MALL &&
        nodeData?._Associations?.Bokforingsmall?.id != null
      ) {
        newValues.push([
          {
            associationName: 'Bokforingsmall',
            operation: 'Ref',
            id: nodeData._Associations.Bokforingsmall.id,
          },
        ]);
      }

      const copyRowsValues = copyRows(bokforderContext.makeNewRow, rows ?? []);

      newValues = [...newValues, ...copyRowsValues];

      if (nodeData.Variant === TEDEKBokforderVariantEnum.MALL) {
        rows?.forEach((row, index) => {
          const rowID = `${NEWLY_ADDED_ID_PREFIX_FOR_UPDATE}Bokforder_Rad_${index}`;
          rowsForTemplate.push({
            id: rowID,
            MALLRAD_LOPNR: row.MALLRAD_LOPNR,
          });
        });

        const templateID = nodeData._Associations?.Bokforingsmall?.id;

        const template = bokforderContext.templates.find(
          template => template.id === templateID
        );

        if (template) {
          newValues.push([
            {
              associationName: 'Bokforingsmall',
              operation: 'Ref',
              id: template.id,
              values: { id: template.id },
            },
          ]);

          bokforderContext.makeTemplateRowsArray(template, rowsForTemplate);
        }
      }

      formContextUpdate?.(
        [
          [
            {
              operation: 'OwnFields',
              values: {
                TEXT: 'Kopia - ' + nodeData.TEXT,
                PARAMVALUES: nodeData.PARAMVALUES,
                MALL_DATUM: nodeData.MALL_DATUM,
                MALL_IDENTIFIKATION: nodeData.MALL_IDENTIFIKATION,
                MALL_LIKVIDSATT: nodeData.MALL_LIKVIDSATT,
                MALL_PLATS: nodeData.MALL_PLATS,
                MALL_ANDAMAL: nodeData.MALL_ANDAMAL,
              },
            },
          ],
          ...newValues,
        ],
        true
      );
      bokforderContextSetBokforderVariant(nodeData?.Variant);
    },
    skip: bfoQuerySkip,
    fetchPolicy: 'network-only',
  });

  const { loading: copyUtanordningLoading } = useQuery<
    UtanordningQuery,
    UtanordningQueryVariables
  >(queryUtanordning, {
    variables: { id: copyID },
    onCompleted: data => {
      const utanordningData = data.node as UtanordningQuery_node_TEDEKBokforder;

      const rows = utanordningData?._Associations?.Rader;
      const newValues: FormUpdateAssociatonType[][] = copyRows(
        bokforderContext.makeNewRow,
        rows ?? []
      );

      if (utanordningData._Associations?.Utbetalningssatt) {
        newValues.push([
          {
            associationName: 'Utbetalningssatt',
            operation: 'Ref',
            id: utanordningData._Associations.Utbetalningssatt.id,
            values: {
              BENAMNING:
                utanordningData._Associations.Utbetalningssatt.BENAMNING,
            },
          },
        ]);
      }

      formContextUpdate?.(
        [
          [
            {
              operation: 'OwnFields',
              values: {
                TEXT: 'Kopia - ' + utanordningData.TEXT,
                U_BANK: utanordningData.U_BANK,
                U_BELOPP: utanordningData.U_BELOPP,
                U_BETALNINGSMOTTAGARE: utanordningData.U_BETALNINGSMOTTAGARE,
                U_BETSATT_ID: utanordningData.U_BETSATT_ID,
                U_CLEARING_BANKKONTONUMMER:
                  utanordningData.U_CLEARING_BANKKONTONUMMER,
                U_FRITEXT: utanordningData.U_FRITEXT,
                U_UTBETALNINGSKATEGORI: utanordningData.U_UTBETALNINGSKATEGORI,
              },
            },
          ],
          ...newValues,
        ],
        true
      );
      bokforderContextSetBokforderVariant(utanordningData?.Variant);
    },
    skip: utanordningQuerySkip,
    fetchPolicy: 'network-only',
  });

  const kodplanID = useMemo(
    () => kodplanContext.activeKodplan?.id ?? '',
    [kodplanContext.activeKodplan?.id]
  );

  const newBfoRowsFromVerRows = useMemo(() => {
    return makeBfoRowsFromVerRows(
      bokforderContext.bokforderVariant ===
        TEDEKBokforderVariantEnum.PERIODISERA
        ? periodChosenRows
        : chosenRows,
      bokforderContext.bokforderVariant,
      currFormatter
    );
  }, [bokforderContext.bokforderVariant, chosenRows, periodChosenRows]);

  const onCancel = useCallback(() => {
    formContextDispatch?.({ type: 'CANCEL' });
  }, [formContextDispatch]);

  const onUseClick = useCallback(() => {
    if (bokforderContextBokforderVariant === TEDEKBokforderVariantEnum.MALL) {
      bokforderContextOnTemplateChange(choosenTemplate);
    }

    if (
      bokforderContext.bokforderVariant ===
        TEDEKBokforderVariantEnum.UTANORDNINGTILLGODO &&
      valdTillgodoKund != null
    ) {
      const formUpdateTillgodo =
        getFormUpdateWithKundInformation(valdTillgodoKund);
      formContextUpdate?.(formUpdateTillgodo);
      //Lagra värdet för den valda kundtypen i bokforderContext

      bokforderContextSetTillgohavandeKundTyp(
        valdTillgodoKund?._Associations?.OrgPers?._typ
      );
      bokforderContextGetKonteringsmall({
        variables: {
          dbname: activeDatabase ?? '',
          bokfDatum: bokforderContextBokforderDate.toLocaleDateString('sv-SE'),
          underlag: [
            valdTillgodoKund._Associations?.KundKategori.id ??
              'felaktig kundkategori id',
            props.bokfgruppId ?? 'felaktig bokfgrupp id',
            valdTillgodoKund.id,
          ],
        },
      });

      const updateValue: FormUpdateAssociatonType[] = [
        {
          operation: 'Ref',
          associationName: 'Kund',
          id: valdTillgodoKund.id,
          values: {
            id: valdTillgodoKund.id,
            Tillgodohavande: valdTillgodoKund?.Tillgodohavande,
          },
        },
      ];
      formContextUpdate?.(updateValue);
    }

    bokforderWrapperContextSetCreateOptionDialogOpen(
      CreateDialogOpenEnum.CLOSED
    );
  }, [
    activeDatabase,
    bokforderContextBokforderDate,
    bokforderContextBokforderVariant,
    bokforderContextOnTemplateChange,
    bokforderContextSetTillgohavandeKundTyp,
    bokforderContext.bokforderVariant,
    bokforderContextGetKonteringsmall,
    bokforderWrapperContextSetCreateOptionDialogOpen,
    choosenTemplate,
    formContextUpdate,
    props.bokfgruppId,
    valdTillgodoKund,
  ]);

  const getUseBtnDisabledString = useCallback((): string => {
    if (
      bokforderContext.bokforderVariant === TEDEKBokforderVariantEnum.MALL &&
      choosenTemplate === null
    ) {
      return 'Du har inte valt en mall';
    }

    if (bokforderContext.isVerifikation) {
      const autoKontering = chosenRows.some(
        row => row.Automatkonterat === YesOrNoEnum.Yes
      );
      const period = chosenRows.some(
        row => row.Periodiserad === YesOrNoEnum.Yes
      );

      if (autoKontering && period) {
        return 'Automatkonterade samt periodiserade rader kan inte hanteras via Bokföringsorder';
      }

      if (period) {
        return 'Periodiserade rader kan inte hanteras via Bokföringsorder';
      }

      if (autoKontering) {
        return 'Automatkonterade rader går ej att välja';
      }

      if (
        periodChosenRows.length === 0 &&
        bokforderContext.bokforderVariant ===
          TEDEKBokforderVariantEnum.PERIODISERA
      ) {
        return 'Du måste periodisera någon rad för att kunna gå vidare';
      }

      if (
        chosenRows.length === 0 &&
        bokforderContext.bokforderVariant !==
          TEDEKBokforderVariantEnum.PERIODISERA
      ) {
        return 'Du måste välja någon rad för att kunna gå vidare';
      }
    }

    if (
      valdTillgodoKund == null &&
      bokforderContext.bokforderVariant ===
        TEDEKBokforderVariantEnum.UTANORDNINGTILLGODO
    ) {
      return 'Du måste välja en kund för att kunna gå vidare';
    }

    return '';
  }, [
    bokforderContext.bokforderVariant,
    bokforderContext.isVerifikation,
    choosenTemplate,
    chosenRows,
    periodChosenRows.length,
    valdTillgodoKund,
  ]);

  const isNextDisabled = useCallback(() => {
    return (
      selectedVerRow && (selectedVerRow.id === '' || selectedVerRow.id == null)
    );
  }, [selectedVerRow]);

  const isOmbokforDisabled = useMemo((): string => {
    if (selectedVerRow?.harAndringsVerifikation) {
      return 'Verifikationen har en ändringsverifikation och kan inte hanteras via Bokföringsorder';
    }

    switch (selectedVerRow?.verkatKod) {
      case TEDEKBokfverVERKAT_KODEnum.LR_DEFINITIVBOKNING:
        return '';

      case TEDEKBokfverVERKAT_KODEnum.EK_VERIFIKATIONSREGISTRERING:
        return '';

      case TEDEKBokfverVERKAT_KODEnum.EK_IMPORT_ENLIGT_SIE:
        return '';

      case TEDEKBokfverVERKAT_KODEnum.EK_BOKFORINGSFIL_FRAN_KOB:
        return '';

      case TEDEKBokfverVERKAT_KODEnum.WEK_BOKFORINGSORDER:
        return '';

      default:
        return 'Verifikation kan inte ombokföras';
    }
  }, [selectedVerRow]);

  const isVandOrKopieraDisabled = useMemo((): string => {
    if (selectedVerRow?.harAndringsVerifikation) {
      return 'Verifikationen har en ändringsverifikation och kan inte hanteras via Bokföringsorder';
    }

    switch (selectedVerRow?.verkatKod) {
      case TEDEKBokfverVERKAT_KODEnum.EK_VERIFIKATIONSREGISTRERING:
        return '';
      case TEDEKBokfverVERKAT_KODEnum.WEK_BOKFORINGSORDER:
        return '';
      default:
        return 'Verifikation kan inte vändas eller kopieras';
    }
  }, [selectedVerRow]);

  const isPeriodiseraButtonDisabled = useMemo((): string => {
    if (selectedVerRow?.harAndringsVerifikation) {
      return 'Verifikationen har en ändringsverifikation och kan inte hanteras via Bokföringsorder';
    }
    switch (selectedVerRow?.verkatKod) {
      case TEDEKBokfverVERKAT_KODEnum.EK_VERIFIKATIONSREGISTRERING:
        return '';
      case TEDEKBokfverVERKAT_KODEnum.LR_DEFINITIVBOKNING:
        return '';
      case TEDEKBokfverVERKAT_KODEnum.WEK_BOKFORINGSORDER:
        return '';
      default:
        return 'Verifikation kan inte periodiseras';
    }
  }, [selectedVerRow]);

  const createBfoRowsFromVerRows = useCallback(() => {
    const newValues: FormUpdateAssociatonType[][] = [];
    const textPrefix = getTitlePrefix(bokforderContext.bokforderVariant);
    const verBokfDate = new Date(verification?.BOKF_AR);
    const today = new Date();

    newValues.push([
      {
        operation: 'OwnFields',
        values: {
          TEXT: `${textPrefix} av verifikation ${getYear(verBokfDate)}/${
            verification?.VER_NR
          } - ${verification?.TEXT}`,
        },
      },
    ]);

    newBfoRowsFromVerRows.forEach((row, index) => {
      newValues.push(
        bokforderContextMakeNewRow(row.id, {
          DEBET: currFormatter.parser.parse(row.Debet ?? '').value,
          KREDIT: currFormatter.parser.parse(row.Kredit ?? '').value,
          TEXT: includeRowText ? row.Text : null,
          REF_LOPNR: row.refLopnr,
          PERIODISERAD:
            row.periodFrom && row.periodTo
              ? TEDEKBokforderRadPERIODISERADEnum.JA
              : null,
          PERIODISERAD_FROM_DATUM: row.periodFrom ?? null,
          PERIODISERAD_TOM_DATUM: row.periodTo ?? null,
        })
      );

      if (bokforderContext.isFromEkA) {
        const availableAttestanter =
          bokforderContext.allBokforderUsersWithKodbeh;

        const meAttestant = availableAttestanter.find(
          attestant => attestant.userID === userID
        );

        newValues.push([
          {
            associationName: 'Rader',
            operation: 'Add_Values',
            id: row.id,
          },
          {
            associationName: 'Attestant',
            operation: 'Ref',
            values: {
              id: meAttestant?.userID ?? 'Didnt find logged in user id',
            },
          },
        ]);
      }

      if (row._Associations) {
        for (let kontodel in row._Associations) {
          const newKontodel = (
            row._Associations as unknown as Record<
              string,
              { ORDNINGS_NR?: number; KONTODEL?: string; id?: string } | null
            >
          )[kontodel];

          const actualKontodel = getKontodelByKontodel(
            kodplanID,
            newKontodel?.ORDNINGS_NR ?? -1,
            newKontodel?.KONTODEL ?? '',
            today
          );

          if (actualKontodel) {
            const visibleByDate = isVisibleByKontodelDate(
              actualKontodel,
              today
            );

            if (visibleByDate && actualKontodel.aktiv) {
              newValues.push([
                {
                  associationName: 'Rader',
                  operation: 'Add_Values',
                  id: row.id,
                },
                {
                  associationName: `${kontodel}`,
                  operation: 'Ref',
                  id: newKontodel?.id ?? null,
                  values: newKontodel?.id ? { id: newKontodel?.id } : null,
                },
              ]);
            }
          }
        }
      }
    });

    if (
      verification &&
      (bokforderContext.bokforderVariant ===
        TEDEKBokforderVariantEnum.OMBOKFOR ||
        bokforderContext.bokforderVariant === TEDEKBokforderVariantEnum.VAND ||
        bokforderContext.bokforderVariant ===
          TEDEKBokforderVariantEnum.PERIODISERA)
    ) {
      const verificationRefValue: FormUpdateAssociatonType[] = [
        {
          operation: 'Ref',
          associationName: 'RefBokfver',
          values: {
            id: verification.id,
          },
        },
      ];

      newValues.push(verificationRefValue);
    }
    formContextUpdate?.(newValues, true);

    bokforderContextSetNewRowIndex(newBfoRowsFromVerRows.length);
  }, [
    bokforderContext.bokforderVariant,
    bokforderContextSetNewRowIndex,
    bokforderContextMakeNewRow,
    bokforderContext.isFromEkA,
    bokforderContext.allBokforderUsersWithKodbeh,
    verification,
    newBfoRowsFromVerRows,
    formContextUpdate,
    includeRowText,
    userID,
    getKontodelByKontodel,
    kodplanID,
  ]);

  const footerActions: IDialogFooterActionButton[] = useMemo(() => {
    const actions: IDialogFooterActionButton[] = [
      {
        label: 'Avbryt',
        onClick: onCancel,
      },
    ];

    if (
      bokforderContext.bokforderVariant === TEDEKBokforderVariantEnum.TOM ||
      bokforderContext.bokforderVariant === TEDEKBokforderVariantEnum.MALL ||
      bokforderContext.bokforderVariant ===
        TEDEKBokforderVariantEnum.UTANORDNINGTILLGODO
    ) {
      const useButton: IDialogFooterActionButton = {
        label: getCreateDialogFooterActionLabel(
          bokforderContext.bokforderVariant
        ),
        onClick: () => {
          if (
            formContext?.formState.formHasChanged &&
            bokforderWrapperContext.createOptionDialogOpen ===
              CreateDialogOpenEnum.OPENFROMDETAIL
          ) {
            bokforderContextSetAreYouSureModalOpen(true);
            bokforderContextSetAreYouSureModalCallback({
              callback: onUseClick,
            });
          } else {
            onUseClick();
          }
        },
        buttonProps: {
          disabled: getUseBtnDisabledString().length > 0,
          disabledReason: getUseBtnDisabledString(),
        },
      };

      actions.push(useButton);
    }
    if (bokforderContext.isVerifikation) {
      const copyButton: IDialogFooterActionButton = {
        label: 'Kopiera',
        onClick: () => {
          setStep(2);

          bokforderContextSetBokforderVariant(
            TEDEKBokforderVariantEnum.KOPIERA
          );

          const newValues = getOmbokningstypFormUpdateValue(
            TEDEKBokforderVariantEnum.KOPIERA
          );
          formContextUpdate?.(newValues);
        },
        buttonProps: {
          disabled: isNextDisabled() || isVandOrKopieraDisabled.length > 0,
          disabledReason: isVandOrKopieraDisabled,
        },
      };
      const periodButton: IDialogFooterActionButton = {
        label: 'Periodisera',
        onClick: () => {
          setStep(2);

          bokforderContextSetBokforderVariant(
            TEDEKBokforderVariantEnum.PERIODISERA
          );

          const newValues = getOmbokningstypFormUpdateValue(
            TEDEKBokforderVariantEnum.PERIODISERA
          );
          formContextUpdate?.(newValues);
        },
        buttonProps: {
          disabled: isNextDisabled() || isPeriodiseraButtonDisabled.length > 0,
          disabledReason: isPeriodiseraButtonDisabled,
        },
      };

      const rebookButton: IDialogFooterActionButton = {
        label: 'Ombokför',
        onClick: () => {
          setStep(2);
          bokforderContextSetBokforderVariant(
            TEDEKBokforderVariantEnum.OMBOKFOR
          );

          const ombokningstyp = translateBokforderTypeToOmforingsType(
            TEDEKBokforderVariantEnum.OMBOKFOR
          );

          const newValues: FormUpdateAssociatonType[] = [
            {
              operation: 'OwnFields',
              values: {
                OMFORINGSTYP: ombokningstyp,
              },
            },
          ];
          formContextUpdate?.(newValues);
        },
        buttonProps: {
          disabled: isNextDisabled() || isOmbokforDisabled.length > 0,
          disabledReason: isOmbokforDisabled,
        },
      };

      const reverseVerButton: IDialogFooterActionButton = {
        label: 'Vänd',
        onClick: () => {
          setStep(2);
          bokforderContextSetBokforderVariant(TEDEKBokforderVariantEnum.VAND);

          const ombokningstyp = translateBokforderTypeToOmforingsType(
            TEDEKBokforderVariantEnum.VAND
          );

          const newValues: FormUpdateAssociatonType[] = [
            {
              operation: 'OwnFields',
              values: {
                OMFORINGSTYP: ombokningstyp,
              },
            },
          ];
          formContextUpdate?.(newValues);
        },
        buttonProps: {
          disabled:
            isNextDisabled() ||
            isVandOrKopieraDisabled.length > 0 ||
            bokforderContext.limitedCreateMode == true,
          disabledReason: isVandOrKopieraDisabled,
        },
      };

      const backButton: IDialogFooterActionButton = {
        label: 'Tillbaka',
        onClick: () => {
          setStep(1);
        },
      };
      const useVerButton: IDialogFooterActionButton = {
        label: 'Använd',
        onClick: () => {
          const someKontodelarInactive = newBfoRowsFromVerRows.some(row => {
            const today = new Date();

            for (let kontodel in row?._Associations) {
              const newKontodel = (
                row._Associations as unknown as Record<
                  string,
                  {
                    ORDNINGS_NR?: number;
                    KONTODEL?: string;
                    id?: string;
                  } | null
                >
              )[kontodel];

              if (newKontodel) {
                const actualKontodel = getKontodelByKontodel(
                  kodplanID,
                  newKontodel?.ORDNINGS_NR ?? -1,
                  newKontodel?.KONTODEL ?? '',
                  today
                );

                if (actualKontodel) {
                  const visibleByDate = isVisibleByKontodelDate(
                    actualKontodel,
                    today
                  );

                  if (!visibleByDate || !actualKontodel.aktiv) {
                    return true;
                  }
                }
              }
            }

            return false;
          });

          if (someKontodelarInactive) {
            setWarningDialogOpen(true);
          } else {
            createBfoRowsFromVerRows();
            bokforderWrapperContextSetCreateOptionDialogOpen(
              CreateDialogOpenEnum.CLOSED
            );
          }
        },
        buttonProps: {
          disabled: getUseBtnDisabledString().length > 0,
          disabledReason: getUseBtnDisabledString(),
        },
      };

      if (step === 1) {
        if (bokforderContext.limitedCreateMode) {
          actions.push(periodButton, rebookButton, reverseVerButton);
        } else {
          actions.push(
            periodButton,
            copyButton,
            rebookButton,
            reverseVerButton
          );
        }
      }

      if (step === 2) {
        actions.push(backButton, useVerButton);
      }
    }

    return actions;
  }, [
    createBfoRowsFromVerRows,
    onCancel,
    bokforderContext.bokforderVariant,
    bokforderContext.isVerifikation,
    bokforderContext.limitedCreateMode,
    getUseBtnDisabledString,
    bokforderWrapperContext,
    bokforderContextSetAreYouSureModalOpen,
    bokforderContextSetAreYouSureModalCallback,
    bokforderWrapperContextSetCreateOptionDialogOpen,
    formContextUpdate,
    formContext?.formState.formHasChanged,
    onUseClick,
    isNextDisabled,
    isVandOrKopieraDisabled,
    isPeriodiseraButtonDisabled,
    isOmbokforDisabled,
    step,
    bokforderContextSetBokforderVariant,
    newBfoRowsFromVerRows,
    getKontodelByKontodel,
    kodplanID,
  ]);

  const isOpen = (): boolean => {
    if (
      (formContext?.isNew &&
        bokforderWrapperContext.createOptionDialogOpen ===
          CreateDialogOpenEnum.OPENFROMLIST &&
        (bokforderContext.bokforderVariant === TEDEKBokforderVariantEnum.MALL ||
          bokforderContext.isVerifikation ||
          bokforderContext.bokforderVariant ===
            TEDEKBokforderVariantEnum.UTANORDNINGTILLGODO)) ||
      copyBfoLoading ||
      copyUtanordningLoading
    ) {
      if (!isOriginal && !copyBfoLoading && !copyUtanordningLoading) {
        //När man kopierar en befintlig och den är färdigladdag så ska man stänga dialogen med laddningsikonen
        bokforderWrapperContextSetCreateOptionDialogOpen(
          CreateDialogOpenEnum.CLOSED
        );
        //Behövs egentligen inte eftersom vi renderar om komponenten när vi uppdaterar bokforderWrapperContext
        return false;
      }
      return true;
    } else {
      return false;
    }
  };

  const dialogSizeProp = () => {
    const result = {
      fullHeight: false,
      fullWidth: false,
    };

    if (
      bokforderContext.isVerifikation ||
      bokforderContext.bokforderVariant ===
        TEDEKBokforderVariantEnum.UTANORDNINGTILLGODO
    ) {
      result.fullHeight = true;
      result.fullWidth = true;
    }
    return result;
  };

  const dialogSizeObj = dialogSizeProp();

  return (
    <EDDialog
      open={isOpen()}
      onClose={onCancel}
      fullHeight={dialogSizeObj.fullHeight}
      fullWidth={dialogSizeObj.fullWidth}
      maxWidth="lg"
      PaperProps={{
        style: {
          ...(isMediumOrLarger && { minWidth: '25rem' }),
          ...(bokforderContext.templates.length === 0 && {
            minHeight: '13rem',
          }),
        },
      }}
      footerActions={!isOriginal ? undefined : footerActions}
      title={
        !isOriginal
          ? 'Kopierar Bokföringsordern'
          : type === TEDEKBokforderTYPEnum.UTANORDNING
          ? 'Skapa Utanordning'
          : 'Skapa Bokföringsorder'
      }
      onExited={() => {
        setTimeout(() => {
          if (bokforderContext.focusRef) {
            if (isMediumOrLarger) {
              bokforderContext.focusRef.current?.focus();
              const inputField = bokforderContext.focusRef.current;
              if (inputField) {
                if (inputField.value.length > 0) {
                  inputField.setSelectionRange(0, inputField.value.length);
                }
              }
            }
          }
        }, 10);
      }}
      subtitle={
        bokforderContext.isVerifikation
          ? `Steg ${step} av 2${step === 2 ? ', välj rader att hantera' : ''}`
          : undefined
      }
    >
      {bokforderContext.isVerifikation && (
        <BokforderVerificationWizard
          chosenRows={chosenRows}
          includeRowText={includeRowText}
          periodChosenRows={periodChosenRows}
          selectedVerRow={selectedVerRow}
          setChosenRows={setChosenRows}
          setIncludeRowText={setIncludeRowText}
          setPeriodChosenRows={setPeriodChosenRows}
          setSelectedVerRow={setSelectedVerRow}
          setVerification={setVerification}
          step={step}
        />
      )}

      {bokforderContext.bokforderVariant === TEDEKBokforderVariantEnum.MALL &&
        (konteringContext.konteringValidationQueryLoading || !isOriginal ? (
          <EDAvenyProgress />
        ) : (
          <BokforderTemplateView
            id={'new'}
            choosenTemplate={choosenTemplate}
            setChoosenTemplate={setChoosenTemplate}
            skipAreYouSureDialog={true}
          />
        ))}

      {bokforderContext.bokforderVariant ===
        TEDEKBokforderVariantEnum.UTANORDNINGTILLGODO && (
        <UtanordningTillgodoDialog
          valdTillgodoKund={valdTillgodoKund}
          setValdTillgodoKund={setValdTillgodoKund}
        />
      )}

      <EDDialog
        footerActions={[
          {
            label: 'Avbryt',
            onClick: () => {
              setWarningDialogOpen(false);
            },
          },
          {
            label: 'Fortsätt',
            onClick: () => {
              createBfoRowsFromVerRows();
              bokforderWrapperContextSetCreateOptionDialogOpen(
                CreateDialogOpenEnum.CLOSED
              );
            },
          },
        ]}
        noCloseIcon
        open={warningDialogOpen}
        title={'Ofullständig kontering'}
      >
        <EDTypography bold>
          Valda rader innehåller en eller flera koddelar som är inaktiva.
        </EDTypography>
        <EDTypography bold>Komplettera konteringen i nästa steg.</EDTypography>
      </EDDialog>

      {(copyBfoLoading || copyUtanordningLoading) && (
        <EDBox sx={theme => ({ height: theme.spacing(10) })}>
          <EDAvenyProgress />
        </EDBox>
      )}
    </EDDialog>
  );
};

export default BokforderCreateDialog;
